import { defineMessages } from "react-intl";
const localized = defineMessages({
  datePickerClearLabel: {
    id: "dateRangePickerClearLabel",
    defaultMessage: "Clear"
  }
});
export {
  localized
};
//# sourceMappingURL=DatePicker.localize.js.map
